import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useTimeMachine } from '../../context/time-machine-context';
import { siteService } from '@/services/site.service';

export const Clock = () => {
	const { SiteConfigsData } = useGetSiteConfigs();
	const { pointValue, is2HTemp, currentMatchTimeValue } = useTimeMachine();
	const getRotateCss = (value: number) => {
		return `translateY(-50%) rotate( calc(( ${value} * ${is2HTemp ? 4 : 2}deg ) * 1`;
	}
	return (
		<div className="tm-clock">
			<div className="tm-text-st">0&apos;</div>
			<div className="tm-text-ht">45&apos;</div>
			<div className="tm-text-ft">90&apos;</div>
			<div className="tm-clock__bet-time">{pointValue}&apos;</div>
			<div className="tm-clock__time">
				<div className="tm-clock__match-time" style={{ transform: getRotateCss((currentMatchTimeValue - (is2HTemp ? 45 : 0))) }}>
					<img src={siteService.combineImagePath('/images/time-machine/time_machine_indicator_short.png', true, SiteConfigsData)}></img>
				</div>
				<div className="tm-clock__select-time" style={{ transform: getRotateCss((pointValue - (is2HTemp ? 45 : 0))) }}>
					<img src={siteService.combineImagePath('/images/time-machine/time_machine_indicator_long.png', true, SiteConfigsData)}></img>
				</div>
			</div>
			<div className="tm-clock__bg">
				<img src={siteService.combineImagePath('/images/time-machine/tm_clock_bg.png', true, SiteConfigsData)}></img>
			</div>
		</div>
	)
}